import { Box, Typography } from "@mui/material";
import CustomerDetailsTabs from "./CustomerManagementTaps/CustomerDetailsTabs";
import { useRTL } from "hooks/isRTL";
import BackButton from "Components/shared/BackButton";

const CustomerDetails = () => {
  const { t } = useRTL();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        padding: "2rem 4rem",
      }}
    >
      <BackButton text={t("backToCustomerManagement")} />
      <Typography variant="h3">{t("customerDetails")}</Typography>
      <CustomerDetailsTabs />
    </Box>
  );
};

export default CustomerDetails;
